/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import AppointmentAction from 'DesignSystem/AppointmentAction/index'
import React from 'react'
import ScheduleViaDialog from './ScheduleViaDialog/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/AppointmentActions/ScheduleViaSMSOrEmail/Content"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<AppointmentAction
  viewPath={`${viewPath}/AppointmentAction`}
 text="Schedule via SMS / Email"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'ScheduleViaDialog/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'ScheduleViaDialog/Content'))}
/>
<ScheduleViaDialog
  viewPath={`${viewPath}/ScheduleViaDialog`}
/>
{children}
</React.Fragment>)
}